module.exports = __webpack_public_path__ + "img/ruou-chivas-12-750-ml-2.816481ca.jpg";